var _defs, _g, _title, _g2, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPestMissing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m232,376.5l150,-150l-150,-150l-150,150l150,150z",
    id: "eQcxmQQO7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 412,
    height: 412,
    id: "canvas_background",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "shadow8464584",
    x: -28,
    y: -33.5,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "m200,350l150,-150l-150,-150l-150,150l150,150z",
    id: "eaS4zfCwF",
    fill: "white",
    filter: "url(#shadow8464584)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eQcxmQQO7",
    fill: "#8A2BE2",
    id: "svg_4",
    y: -26.5,
    x: -31.999999
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eQcxmQQO7",
    fillOpacity: 0,
    stroke: "#8A2BE2",
    strokeWidth: 90,
    strokeOpacity: 0.67,
    id: "svg_6",
    y: -26.5,
    x: -31.999999
  }))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    d: "m232,376.5l150,-150l-150,-150l-150,150l150,150z"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      cursor: "text"
    },
    fill: "#ffffff",
    strokeWidth: 0,
    x: 159,
    y: 186.37931,
    id: "svg_33",
    fontSize: 24,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold",
    transform: "matrix(7.680336, 0, 0, 7.609162, -1073.823608, -1149.69873)",
    stroke: "#000"
  }, "P")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPestMissing);
export default __webpack_public_path__ + "static/media/PestMissing.bb9b7852ffbaa969335891812d744a19.svg";
export { ForwardRef as ReactComponent };